var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7509 6.93945C10.7509 6.52524 10.4151 6.18945 10.0009 6.18945C9.58665 6.18945 9.25087 6.52524 9.25087 6.93945V9.24215H6.94531C6.5311 9.24215 6.19531 9.57794 6.19531 9.99215C6.19531 10.4064 6.5311 10.7422 6.94531 10.7422H9.25087V13.0447C9.25087 13.459 9.58665 13.7947 10.0009 13.7947C10.4151 13.7947 10.7509 13.459 10.7509 13.0447V10.7422H13.0564C13.4706 10.7422 13.8064 10.4064 13.8064 9.99215C13.8064 9.57794 13.4706 9.24215 13.0564 9.24215H10.7509V6.93945Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9061 1.66699H6.09654C3.37432 1.66699 1.66797 3.59373 1.66797 6.32129V13.6794C1.66797 16.4069 3.36638 18.3337 6.09654 18.3337H13.9061C16.6362 18.3337 18.3346 16.4069 18.3346 13.6794V6.32129C18.3346 3.59373 16.6362 1.66699 13.9061 1.66699Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.903293f7ff6d3c0d5843786aeccb1223.svg";
export { ForwardRef as ReactComponent };